// extracted by mini-css-extract-plugin
export default {"buttonClass":"Footer_buttonClass__i+MW1"};